import { endMetadataMerge } from "../../lib/metadata-history/dispatch";
import { Input } from "../ui/input";
import { useEffect, useState } from "react";

type TextNumberFieldProps = {
  label: string;
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
};

export function TextNumberField({ label, value, min, max, step = 1, onChange }: TextNumberFieldProps) {
  const [draft, setDraft] = useState(String(value));
  useEffect(() => setDraft(String(value)), [value]);
  return (
    <label className="grid min-w-0 content-start gap-1 text-xs font-medium">
      {label}
      <Input type="number" value={draft} min={min} max={max} step={step} className="h-8 text-xs"
        onBlur={() => { setDraft(String(value)); endMetadataMerge(); }} onChange={event => {
          setDraft(event.target.value);
          const next = event.target.valueAsNumber;
          if (!Number.isFinite(next)) return;
          if (min !== undefined && next < min) return;
          if (max !== undefined && next > max) return;
          onChange(next);
        }} />
    </label>
  );
}
